import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DayOfTheWeek } from '../../enums/day-of-week';
import { FormGroup } from '@angular/forms';
import { SiteOpeningHoursForm } from '../../interfaces/customer-sites';
import { Calendar, SelectItem } from 'primeng';
import { startOfDay, isEqual, differenceInMinutes } from 'date-fns';
import { isMidnightMinute } from '../../utils/date-utils';

@Component({
  selector: '[customer-sites-opening-times-row]',
  templateUrl: 'customer-sites-opening-times-row.component.html',
  styleUrls: ['customer-sites-opening-times-row.component.scss'],
})
export class CustomerSitesOpeningTimesRowComponent implements OnInit {
  public hourSelectItems: SelectItem[] = [];

  private _isOpen: boolean;

  @ViewChild('openTime') openTime: Calendar;

  @ViewChild('closeTime') closeTime: Calendar;

  public closeControls() {
    this.openTime.hideOverlay();
    this.closeTime.hideOverlay();
  }

  public set isOpen(value: boolean) {
    if (!value) {
      this.formGroup.controls.open.disable({ emitEvent: false });
      this.formGroup.controls.close.disable({ emitEvent: false });
    } else {
      this.formGroup.controls.open.enable({ emitEvent: false });
      this.formGroup.controls.close.enable({ emitEvent: false });
    }

    this._isOpen = value;
  }

  public get isOpen(): boolean {
    return this._isOpen;
  }

  @Input() public formGroup: FormGroup<SiteOpeningHoursForm>;

  defaultDate = new Date(2020, 1, 1, 9, 0, 0);

  startOfToday = startOfDay(new Date());

  @Input() public disableFields: boolean = false;

  constructor() {}

  public get dayText(): string {
    return DayOfTheWeek[this.formGroup.getRawValue().dayOfWeek].substring(0, 3);
  }

  ngOnInit(): void {
    for (let i = 0; i < 24; i++) {
      let hourString = `${i.toString().padStart(2, '0')}:00`;
      this.hourSelectItems.push({ label: hourString, value: i * 60 });
    }

    this.hourSelectItems.unshift({ label: 'Select', value: null });

    this.isOpen =
      !isEqual(this.formGroup.getRawValue().open, this.startOfToday) &&
      !isEqual(this.formGroup.getRawValue().close, this.startOfToday);

    this.formGroup.controls.open.markAsDirty();
    this.formGroup.controls.close.markAsDirty();
    this.formGroup.controls.open.updateValueAndValidity();
    this.formGroup.controls.close.updateValueAndValidity();

    this.formGroup.valueChanges.subscribe(() => {
      this.checkForClosed();
    });
  }

  hideOpenOverlay() {
    this.openTime.hideOverlay();
  }

  hideCloseOverlay() {
    this.closeTime.hideOverlay();
  }

  onIsOpenChange(value: boolean) {
    if (value) {
      this.formGroup.controls.open.setValue(null);
      this.formGroup.controls.close.setValue(null);
    } else {
      this.formGroup.controls.open.setValue(this.startOfToday);
      this.formGroup.controls.close.setValue(this.startOfToday);
    }
  }

  openChange($event) {
    this.checkForClosed();
  }

  closeChange($event) {
    this.checkForClosed();
  }

  checkForClosed() {
    const form = this.formGroup.getRawValue();

    if (form.open == null || form.close == null) {
      this.isOpen = true;
    }

    if (isMidnightMinute(form.open) && isMidnightMinute(form.close)) {
      this.isOpen = false;
    }
  }
}
